import { Fragment } from "react";

import bg from "assets/img/courses/ai-bg.jpg";
import berkely from "assets/img/common/uc-berkeley.png";
import mit from "assets/img/common/mit.png";
import stanford from "assets/img/common/stanford-horizontal.png";
import jhu from "assets/img/common/jhu.svg";

export const banner = {
  bannerBg: bg,
  heading: "Take the #1 course for high school students in",
  programs: "Quantum Computing",
  courseCreatedBy: {
    para: "Created by researchers at",
    logos: [
      { src: berkely, alt: "Berkely" },
      { src: mit, alt: "MIT" },
      { src: stanford, alt: "Stanford" },
      { src: jhu, alt: "John Hopkins University" },
    ],
  },
  programsTypes: "For High School Students",
  programsFor: <Fragment>Sept 27 - Dec 12, 2026</Fragment>,
  bannerLinks: [
    {
      linkText: (
        <Fragment>
          <span>Enroll Now</span>
        </Fragment>
      ),
      link: "https://www.frontier-tech.org/application-foundations-of-quantum-computing",
      isExternal: true,
    },
    // {
    //   linkText: (
    //     <Fragment>
    //       <span>
    //         Introduction to AI
    //         <span>Apply Now</span>
    //       </span>
    //     </Fragment>
    //   ),
    //   link: "/train-course-application",
    //   isExternal: false,
    // },
  ],
};
